enum PRODUCTS {
  EDR = 'EDR',
  LOG = 'LOG',
  LOG_USER = 'LOG_USER',
  MCSC = 'MCSC',
  MDR = 'MDR',
  NET = 'NET',
  RET = 'RET',
  VMP = 'VMP',
  VMPE = 'VMPE',
  LOG_KANATI = 'LOG_KANATI',
  WRNTY = 'WRNTY'
}
// Constant for all log family products: Log, log user, and log kanati
export const LOG_PRODUCTS: string[] = [
  PRODUCTS.LOG,
  PRODUCTS.LOG_USER,
  PRODUCTS.LOG_KANATI
];

export enum AUTO_SOC_TIERS {
  FORTIFY = 0,
  SECURE = 1,
  DEFEND = 2
}

export enum PRODUCT_SUB_TYPES {
  MSD = 'MSD',
  RANSOM_SNARE = 'RansomSnare'
}

export const PRODUCT_AUTO_SOC_SUB_TYPES = {
  TIER_1: 'Secure',
  TIER_2: 'Defend'
};

export { PRODUCTS };
export default PRODUCTS;
